import React, { useEffect, useState } from 'react';
import { styled, TextField, Typography } from '@mui/material';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

import { SubmitButton } from 'components/ui/buttons';
import { CancelButton } from 'components/ui/buttons';

export default function TextareaDialog(props) {
    const { open, title, defaultValue, disabled, onConfirm, onClose } = props;
    const maxLength = props.maxLength || 2000;

    const [value, setValue] = useState(defaultValue || '');

    const handleSubmit = () => {
        onConfirm(value.trim());
    };

    // Clear text field when dialog is closed
    useEffect(() => {
        if (open === false) {
            setValue('');
        }
    }, [open]);

    const error = value.length > maxLength;

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                {open === true && (
                    <TextField
                        autoFocus
                        multiline
                        variant="outlined"
                        minRows={5}
                        maxRows={5}
                        defaultValue={value}
                        onChange={(e) => setValue(e.target.value)}
                        fullWidth
                        error={error}
                    />
                )}
                {error ? (
                    <CounterError>
                        {String(value.length)} of {maxLength}
                    </CounterError>
                ) : (
                    <Counter>
                        {String(value.length)} of {maxLength}
                    </Counter>
                )}
            </DialogContent>
            <DialogActions>
                <CancelButton onClick={onClose}>Cancel</CancelButton>
                <SubmitButton
                    disabled={disabled || error || value.trim().length === 0}
                    onClick={handleSubmit}
                >
                    Save
                </SubmitButton>
            </DialogActions>
        </Dialog>
    );
}

const Counter = styled(Typography)(({ theme }) => ({
    ...theme.typography.caption,
    textAlign: 'right',
    marginTop: theme.spacing(1),
    color: theme.palette.grey[700],
}));

const CounterError = styled(Typography)(({ theme }) => ({
    ...theme.typography.caption,
    textAlign: 'right',
    marginTop: theme.spacing(1),
    color: theme.palette.error.main,
}));
